module.exports = __webpack_public_path__ + "img/win_item6.a29f3f31.png";